import React, { useEffect, useState } from "react";
import {
  Layout,
  Typography,
  Input,
  Table,
  Flex,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import type { AppDispatch } from "../redux/store";
import CustomTableLoader from "src/components/common/CustomTableLoader";
import { GetOwnerDetails } from "src/redux/actions/OwnerAction";

const OwnerDetails: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const dataSource = useSelector((state: any) => state.ownerdetails.data ?? []);
  const loading = useSelector((state: any) => state.ownerdetails.loading);
  const [searchText, setSearchText] = useState<string>("");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const cityid = userData.cityid;
  const { Title } = Typography;

    useEffect(() => {
      dispatch(GetOwnerDetails());
    }, []);

  const columns: any = [
    {
      title: "Cab ID",
      dataIndex: "cab_id",
      key: "cab_id",
      align: "center",
    },
    {
      title: "Owner ID",
      dataIndex: "owner_id",
      key: "owner_id",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "owner_name",
      key: "owner_name",
      align: "center",
    },
    {
      title: "Mobile Number",
      dataIndex: "owner_mobno",
      key: "owner_mobno",
      align: "center",
    },
    {
      title: "Date of Joining",
      dataIndex: "AttachDate",
      key: "AttachDate",
      align: "center",
      // width: 110,
      // render: (text: any) => text.split(",")[0],
    },
  ];

  //   useEffect(() => {
  //     const from = dayjs();
  //     const to = dayjs();

  //     const toDatePlusOne = to.add(1, "day");
  //     setFromDate(from);
  //     setToDate(to);

  //     dispatch(
  //       fetchCorporateTrip(
  //         from.format("YYYY-MM-DD"),
  //         toDatePlusOne.format("YYYY-MM-DD")
  //       )
  //     );

  //     dispatch(fetchCompany(cityid));
  //   }, []);

  const handleSearch = (value: any) => {
    setSearchText(String(value || ""));
  };

  const filteredDataSource = dataSource.filter((item: any) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  return (
    <Layout
      style={{ minHeight: "100vh", overflow: "hidden", position: "relative" }}
    >
      <Flex
        style={{
          background: "whitesmoke",
          rowGap: "20px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Title
          level={3}
          style={{
            fontSize: "35px",
            fontWeight: "bolder",
            color: "black",
            fontFamily: "serif",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            margin: 0,
          }}
        >
          Owner Details
        </Title>
        <Flex style={{ width: "100%", justifyContent: "end" }}>
          <Input.Search
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onSearch={(value) => handleSearch(value)}
            style={{ width: "20%" }}
          />
        </Flex>

        <Table
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          size="middle"
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 100,
          }}
          dataSource={filteredDataSource}
          columns={columns}
          //   scroll={{ x: "calc(1700px + 50%)", y: 50 * 15 }}
          bordered
          rowKey="bookingId"
        />
      </Flex>
    </Layout>
  );
};

export default OwnerDetails;
